jQuery(function($){
    var $section    = $('.all-posts');
    var $grid       = $section.find('.all-posts__grid');
    var $loader     = $section.find('.all-posts__loader');
    var currentPage = 1;
    var loading     = false;

    $loader.hide();

    function loadNext(){
        if ( loading ) return;
        loading = true;
        currentPage++;
        $loader.show();

        $.post(infiniteScrollVars.ajax_url, {
            action: 'load_all_posts',
            nonce:  infiniteScrollVars.nonce,
            page:   currentPage
        })
            .done(function(response){
                if ( response.success && response.data.html ) {
                    var $items = $(response.data.html)
                        .css({ opacity: 0, transform: 'translateY(20px)' });

                    $grid.append($items);
                    $items.each(function(i, el){
                        setTimeout(function(){
                            $(el).css({
                                transition: 'all 0.5s ease',
                                opacity: 1,
                                transform: 'translateY(0)'
                            });
                        }, i * 100);
                    });
                } else {
                    $(window).off('scroll', onScroll);
                }
            })
            .always(function(){
                loading = false;
                $loader.hide();
            });
    }

    function onScroll(){
        if ( loading ) return;

        var $trigger = $grid.find('.article-card').eq(-3);
        if ( !$trigger.length ) return;

        var triggerTop   = $trigger.offset().top;
        var windowMid    = $(window).scrollTop() + ($(window).height() / 2);

        if ( triggerTop < windowMid ) {
            loadNext();
        }
    }

    $(window).on('scroll', onScroll);
});
